// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__RBtNK","default":"Button_default__1Xe2V","primary":"Button_primary__XYgy-","active":"Button_active__y7gJv"};